export default "__VITE_ASSET__5k3KAyqP__"